import React, { useState } from 'react'

import RncActionContext from 'contexts/RncActionContext'

import * as service from 'service'

const RncActionProvider = ({ children, nonComplianceReportActions }) => {
  const [data, setData] = useState(nonComplianceReportActions)
  const [loading, setLoading] = useState(false)

  const loadData = async (nonComplianceReportId) => {
    setLoading(true)

    let response = await service.dponet.nonComplianceReports.get({
      nonComplianceReportId,
    })

    setData(response?.data?.nonComplianceReport?.nonComplianceReportActions)

    setLoading(false)
  }

  return (
    <RncActionContext.Provider
      value={{
        data,
        setData,
        loading,
        setLoading,
        loadData,
      }}
    >
      {children}
    </RncActionContext.Provider>
  )
}

export default RncActionProvider
